module.exports = __webpack_public_path__ + "img/about_us.ac551778.jpg";